<template>
  <div>
     <v-dialog id="edit-field-dialog" :value="model.active" width="400" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left>{{ selected.id ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ selected.id ? 'Update' : 'Add' }} Field
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form v-model="model.valid" ref="fieldForm">
          <v-combobox outlined dense :items="[]" v-if="false" clearable label="Section" :rules="[formRules.required]"
            placeholder="Enter Field Section..." v-model="selected.section"></v-combobox>
          <v-select :items="taskFieldList" outlined dense clearable label="Field Type" :rules="[formRules.required]"
            placeholder="Select Field Type..." v-model="selected.fieldType"></v-select>
          <v-combobox
            v-if="selected.fieldType === TaskFieldType.Dropdown || selected.fieldType === TaskFieldType.Plan3D"
            v-model="selected.options" @change="handleOptionChange" class="options-wrapper" chips outlined dense
            :rules="[formRules.required]" clearable label="DropDown Options"
            placeholder="Enter options ( Press Enter to confirm )" multiple>
            <template v-slot:selection="data">
              <div class="d-flex align-center pl-4 pr-1 py-1 mr-1 my-1 option-chip"
                :class="{'selected': data.selected}">
                <span class="mr-2 font-weight-medium">{{ data.item.value }}</span>

                <color-picker-button v-if="selected.fieldType === TaskFieldType.Plan3D" v-model="data.item.color"
                  icon="mdi-palette" :size="30" :icon-size="24">
                </color-picker-button>
                <v-btn icon x-small class="ml-1 close-btn" @click.stop="editOption(data.item)">
                  <v-icon small>fa-edit</v-icon>
                </v-btn>
                <v-btn icon x-small class="ml-1 close-btn" @click.stop="removeOption(data.item)">
                  <v-icon small>fa-close</v-icon>
                </v-btn>
              </div>
            </template>
          </v-combobox>

          <v-text-field outlined dense clearable label="Label" :rules="[formRules.required]"
            placeholder="Enter Label..." v-model="selected.label">
          </v-text-field>
          <v-text-field outlined dense clearable label="Placeholder" :rules="[formRules.required]"
            placeholder="Enter Placeholder..." v-model="selected.placeHolder">
          </v-text-field>
          <v-color-picker v-if="selected.fieldType !== 8" width="368" v-model="selected.color"></v-color-picker>
          <v-checkbox label="Enable" v-model="selected.isEnabled"></v-checkbox>
          <v-checkbox label="Grid Visibility" v-model="selected.isVisible"></v-checkbox>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn color="primary" :loading="updateLoading" elevation="0" @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <v-dialog :value="editOptionModal.open" width="348" persistent>
    <v-card v-if="editOptionModal.selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left>mdi-pencil</v-icon>
         Edi Option
        </v-card-title>
        <v-btn icon @click="editOptionModal.open=false"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form v-model="editOptionModal.valid">
          <v-text-field
            outlined
            dense
            clearable
            label="Name"
            :rules="[formRules.required]"
            placeholder="Enter Name..."
            v-model="editOptionModal.selected.value">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="editOptionModal.open=false"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!editOptionModalHasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          @click="editOptionConfirmed"
          :disabled="!editOptionModal.valid || !editOptionModalHasChanges">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
  
</template>

<script>
  import { $isEqual } from '@Utils';
  import formRules from '@Share/config/form-rules';
  import { mapGetters } from 'vuex';
  import { TaskFieldType, taskFieldList } from '@Share/config/enums';
  import ColorPickerButton from '@Share/components/ColorPickerButton.vue';
import { $uuidv4 } from '@/utils';
  
  export default {
    name: 'edit-task-field',
    components: {
      ColorPickerButton
    },
    data() {
      return {
        section: {},
        selected: {},
        selectedCemented: {},
        TaskFieldType,
        formRules,
        taskFieldList,
        selectedType: null,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
        editOptionModal:{
          open:false,
          valid:false,
          selected:{},
          
        }
      };
    },
    computed: {
      editOptionModalHasChanges(){
        
        if(!this.selected||!this.selected.options?.length)
        return false;
        var option=this.selected.options.find(e=>e.id==this.editOptionModal.selected.id);
        if(option==null)
        return false;
        return this.editOptionModal.selected.value!=option.value
      },
      ...mapGetters('TASK_MANAGER', {
        updateLoading: 'GET_UPDATE_LOADING',
      }),
    },
    methods: {
      open(section, item, selectedType) {
        this.model.active = true;
        this.selectedType = structuredClone(selectedType);
        this.section = this.selectedType.sections.find((e) => e.id == section.id);
        if (item) {
          this.selected = structuredClone(item);
          this.checkForOptionIds();
        }
        setTimeout(() => {
          this.cementSelected();
        }, 400);
      },
      checkForOptionIds(){
        if(!this.selected.options?.length)
        return;
      
      for (let i = 0; i < this.selected.options.length; i++) {
        const element = this.selected.options[i];
        if(!element.id)
        element.id==i+1;
        
      }
      },
      saveChanges() {
        if (!this.section.fields) this.section.fields = [];
        if (this.selected.color && this.selected.color.hexa)
          this.selected.color = this.selected.color.hexa;
        if (this.selected.id) {
          const index = this.section.fields.findIndex((elm) => elm.id == this.selected.id);
          if (index !== -1) this.section.fields.splice(index, 1, this.selected);
        } else {
          this.section.fields.push(this.selected);
        }

        this.$store.dispatch('TASK_MANAGER/UPDATE', this.selectedType).then((data) => {
          this.$emit('updateSelected', data);
          this.cementSelected();
          this.closeDialog();
        });
      },
      reset() {
        this.model.active = false;
        this.selected = {};
        this.selectedCemented = {};
        this.model.valid = true;
        this.$refs.fieldForm.resetValidation();
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
      removeOption(item) {
        this.selected.options.splice(this.selected.options.indexOf(item.id), 1);
      },
       editOption(item) {
        
         var option = this.selected.options.find(e=>e.id==item.id);
         this.editOptionModal.selected = structuredClone(option);
         this.editOptionModal.open = true;

      },
      editOptionConfirmed() {
        
        var option=this.selected.options.find(e=>e.id==this.editOptionModal.selected.id);
        option.value=this.editOptionModal.selected.value;
        this.editOptionModal.selected={};
         this.editOptionModal.open=false;

      },
      handleOptionChange(newOptions) {
        
        const newOption = newOptions.find((option) => typeof option === 'string');
        if (newOption) {
          const index = newOptions.indexOf(newOption);
          newOptions.splice(index, 1, { id: $uuidv4(), value: newOption, color: '#FF0000' });
        }
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss">
  #edit-field-dialog {
    .values-wrapper {
      max-height: 120px;
      overflow: auto;
      margin: 8px 0px;
    }
    .option-row {
      padding: 4px 0px;
      border-bottom: 1px solid #e0e0e0;
    }
    .option-row:last-child {
      border-bottom: none;
    }
    .option-row:hover {
      background-color: #f5f5f5;
    }
  }
  
  .options-wrapper {
    .v-select__selections {
      gap: 4px;
      margin-top: 8px;
      padding-bottom: 4px;
    }
    
    .option-chip {
      background-color: #f1f3f5;
      border-radius: 16px;
      height: 32px;
      transition: all 0.2s ease;
      border: 1px solid rgba(0, 0, 0, 0.06);
      position: relative;
      overflow: hidden;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      
      &.selected {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }
      
      &:hover {
        background-color: #e9ebee;
        border-color: rgba(0, 0, 0, 0.1);
      }
      
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.87);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }
      
      .close-btn {
        margin-right: 4px;
        opacity: 0.7;
        transition: all 0.15s ease;
        background-color: transparent !important;
        
        &:hover {
          opacity: 1;
          background-color: rgba(0, 0, 0, 0.05) !important;
        }
        
        .v-icon {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.54);
        }
      }
      
      .v-color-picker-button {
        margin-left: 2px;
        border-left: 1px solid rgba(0, 0, 0, 0.08);
        padding-left: 6px;
        height: 100%;
        display: flex;
        align-items: center;
        
        .v-btn {
          background-color: transparent !important;
          transition: transform 0.2s ease;
          
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
  
  // Dark theme compatibility
  .theme--dark .options-wrapper .option-chip {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.09);
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.12);
    }
    
    span {
      color: rgba(255, 255, 255, 0.9);
    }
    
    .close-btn .v-icon {
      color: rgba(255, 255, 255, 0.7);
    }
    
    .v-color-picker-button {
      border-left-color: rgba(255, 255, 255, 0.1);
    }
  }
</style>